import React, { memo, useMemo } from 'react';
import BreadcrumbsWrapper from './BreadcrumbsWrapper/BreadcrumbsWrapper';
import ToolBarWrapper from './ToolBarWrapper/ToolBarWrapper';
import { st, classes } from './HeaderWrapper.st.css';
import {
  st as breadcrumbsSt,
  classes as breadcrumbsClasses,
} from './BreadcrumbsWrapper/BreadcrumbsWrapper.st.css';
import SearchTextField from './SearchTextField/SearchTextField';
import useObservable from '../../../../Shared/Hooks/useObservable.Hook';
import { getSelectedItems } from '../../../Services/SelectedItems.service';
import { getRootFolder } from '../../../Services/RootFolder.service';
import { getTableSettings } from '../../../Services/TableSettings.service';
import { TableColumns } from '../../../../Constants/TableHeader.Constants';
import { Status } from '../../../../Constants/Permissions';
import { getAppSettings } from '../../../Services/AppSettings.service';

const HeaderWrapper = () => {
  const [, selectedItems]: any = useObservable(getSelectedItems());
  const [, rootFolder]: any = useObservable(getRootFolder());
  const [, tableDisplaySettings]: any = useObservable(getTableSettings());
  const [, appSettings]: any = useObservable(getAppSettings());

  const isEditorX: boolean = appSettings?.isEditor_X ?? false;
  const viewPermissions = useMemo(
    () =>
      rootFolder?.authorizeActions?.find(
        (itemData: any) => itemData.action === 'VIEW',
      ),
    [rootFolder],
  );
  const isSearchEnabled = useMemo(() => {
    if (!tableDisplaySettings?.length) {
      return false;
    }

    return Boolean(
      tableDisplaySettings.find(
        (data: any) => data.id === TableColumns.SEARCH_BAR,
      )?.value,
    );
  }, [tableDisplaySettings]);
  const shouldRenderSearchField =
    isSearchEnabled &&
    rootFolder !== undefined &&
    Boolean(selectedItems) &&
    selectedItems.length <= 0 &&
    !(viewPermissions && viewPermissions.status === Status.FORBIDDEN);

  return (
    <div>
      <div className={st(classes.headerWrapperContainer, { isEditorX })}>
        <div
          className={breadcrumbsSt(breadcrumbsClasses.breadCrumbsContainer)}
          data-hook="breadcrumbs-wrapper"
          style={{ display: 'flex', flexGrow: 1 }}
        >
          <BreadcrumbsWrapper />
        </div>
        <div>
          <ToolBarWrapper />
        </div>
      </div>
      {isSearchEnabled ? (
        shouldRenderSearchField ? (
          <div className={st(classes.searchWrapper, { isEditorX })}>
            <SearchTextField />
          </div>
        ) : (
          <div className={st(classes.searchWrapper, { isEditorX })} />
        )
      ) : (
        <div />
      )}
    </div>
  );
};
HeaderWrapper.displayName = 'HeaderWrapper';
export default memo(HeaderWrapper);
